var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as PropTypes from 'prop-types';
import { customPropTypes, childrenExist, AutoControlledComponent, commonPropTypes, } from '../../lib';
import ListItem from './ListItem';
import { listBehavior } from '../../lib/accessibility';
import { ContainerFocusHandler } from '../../lib/accessibility/FocusHandling/FocusContainer';
/**
 * A list displays a group of related content.
 */
var List = /** @class */ (function (_super) {
    __extends(List, _super);
    function List(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.focusHandler = null;
        _this.itemRefs = [];
        _this.actionHandlers = {
            moveNext: function (e) {
                e.preventDefault();
                _this.focusHandler.moveNext();
            },
            movePrevious: function (e) {
                e.preventDefault();
                _this.focusHandler.movePrevious();
            },
            moveFirst: function (e) {
                e.preventDefault();
                _this.focusHandler.moveFirst();
            },
            moveLast: function (e) {
                e.preventDefault();
                _this.focusHandler.moveLast();
            },
        };
        _this.focusHandler = new ContainerFocusHandler(function () { return _this.props.items.length; }, function (index) {
            _this.setState({ focusedIndex: index }, function () {
                var targetComponent = _this.itemRefs[index] && _this.itemRefs[index].current;
                var targetDomNode = ReactDOM.findDOMNode(targetComponent);
                targetDomNode && targetDomNode.focus();
            });
        });
        return _this;
    }
    List.prototype.getInitialAutoControlledState = function () {
        return { selectedIndex: -1, focusedIndex: 0 };
    };
    List.prototype.renderComponent = function (_a) {
        var ElementType = _a.ElementType, classes = _a.classes, accessibility = _a.accessibility, rest = _a.rest;
        var children = this.props.children;
        return (React.createElement(ElementType, __assign({}, accessibility.attributes.root, accessibility.keyHandlers.root, rest, { className: classes.root }), childrenExist(children) ? children : this.renderItems()));
    };
    List.prototype.renderItems = function () {
        var _this = this;
        var items = this.props.items;
        var _a = this.state, focusedIndex = _a.focusedIndex, selectedIndex = _a.selectedIndex;
        this.focusHandler.syncFocusedIndex(focusedIndex);
        this.itemRefs = [];
        return _.map(items, function (item, idx) {
            var maybeSelectableItemProps = {};
            if (_this.props.selectable) {
                var ref = React.createRef();
                _this.itemRefs[idx] = ref;
                maybeSelectableItemProps.ref = ref;
                maybeSelectableItemProps.onFocus = function () { return _this.setState({ focusedIndex: idx }); };
                maybeSelectableItemProps.onClick = function (e) {
                    _this.trySetState({ selectedIndex: idx });
                    _.invoke(_this.props, 'onSelectedIndexChange', e, __assign({}, _this.props, { selectedIndex: idx }));
                };
                maybeSelectableItemProps.selected = idx === selectedIndex;
                maybeSelectableItemProps.tabIndex = idx === focusedIndex ? 0 : -1;
            }
            var itemProps = __assign({}, _.pick(_this.props, List.itemProps), maybeSelectableItemProps);
            return ListItem.create(item, {
                defaultProps: itemProps,
            });
        });
    };
    List.displayName = 'List';
    List.className = 'ui-list';
    List.propTypes = __assign({}, commonPropTypes.createCommon({
        content: false,
    }), { accessibility: PropTypes.func, debug: PropTypes.bool, items: customPropTypes.collectionShorthand, selectable: PropTypes.bool, truncateContent: PropTypes.bool, truncateHeader: PropTypes.bool, selectedIndex: PropTypes.number, defaultSelectedIndex: PropTypes.number, onSelectedIndexChange: PropTypes.func });
    List.defaultProps = {
        as: 'ul',
        accessibility: listBehavior,
    };
    List.autoControlledProps = ['selectedIndex'];
    List.Item = ListItem;
    // List props that are passed to each individual Item props
    List.itemProps = ['debug', 'selectable', 'truncateContent', 'truncateHeader', 'variables'];
    return List;
}(AutoControlledComponent));
export default List;
